export const STORE_REWARD = 'STORE_REWARD'
export const CLEAR_REWARDS = 'CLEAR_REWARDS'
export const STOP_SPIN = 'STOP_SPIN'
export const CONTINUE_SPIN = 'CONTINUE_SPIN'
